import { Box } from '@mui/material';

import { CheckboxButton } from '@/components';
import {
  onboardingActions,
  selectOnboardingStepInputs,
  STEP_IDS,
  useAppDispatch,
  useAppSelector,
} from '@/store';

import { styles } from '../styles';
import { getDesignationYearOptions } from '../utils';
import { Footer } from './Footer';
import { Header } from './Header';
import { ModalSubtitle } from './ModalSubtitle';
import { ModalTitle } from './ModalTitle';

export const BmuCpaYearForm = () => {
  const dispatch = useAppDispatch();

  const stepInputs = useAppSelector(selectOnboardingStepInputs);

  const { value: year } = stepInputs[STEP_IDS.bmuCpaYear];
  const designationYearOptions = getDesignationYearOptions();

  return (
    <Box sx={styles.formContainer}>
      <Header Title={<Title />} Subtitle={<Subtitle />} />
      <Box sx={styles.formPrimarySection}>
        {Object.keys(designationYearOptions)
          .map(Number)
          .reverse()
          .map(i => (
            <Box key={i} sx={styles.checkboxContainer}>
              <CheckboxButton
                label={designationYearOptions[i].toString()}
                checked={i === year}
                onChange={() =>
                  dispatch(
                    onboardingActions.updateStepInputs({
                      step: STEP_IDS.bmuCpaYear,
                      input: i,
                    }),
                  )
                }
              />
            </Box>
          ))}
      </Box>
      <Footer />
    </Box>
  );
};

const Title = () => {
  return (
    <ModalTitle>
      As a <b>CPA</b> in <b>Bermuda</b>, what year did you get your designation?
    </ModalTitle>
  );
};

const Subtitle = () => <ModalSubtitle>Choose one below.</ModalSubtitle>;
